import { axiosApi } from './api'
import { providesList } from 'utils/rtkHelpers'

const type = 'User'

export const user = axiosApi.injectEndpoints({
    endpoints: build => ({
        /*
         * GET user by email id
         */
        getUser: build.query({
            query: emailId => `v1/users/${emailId}`,
            transformResponse: res => res.data,
            providesTags: (result, error, id) => [{ type, id }],
        }),

        /*
         * GET users list by agreement id
         */
        getUsers: build.query({
            query: agreementId => `v1/users/_search?agreementId=${agreementId}`,
            transformResponse: res => res.data,
            providesTags: result => providesList(result, type),
        }),

        /*
         * Invite a user to an agreement
         */
        inviteUser: build.mutation({
            query: body => ({
                url: 'v1/agreements',
                method: 'PUT',
                body,
            }),
            transformResponse: res => res.data,
        }),

        /*
         * Delete a user from an agreement
         */
        deleteUser: build.mutation({
            query: ({ agreementId, id, isWithdraw }) => ({
                url: `v1/agreements/${agreementId}/users/${id}?isWithdraw=${isWithdraw}`,
                method: 'DELETE',
            }),
        }),

        /*
         * Update the profile of authenticated user.
         */
        updateUser: build.mutation({
            query: body => ({
                url: `v1/users/_profile`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: result => (result ? [{ type, id: 'LIST' }] : null),
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetUserQuery,
    useGetUsersQuery,
    useInviteUserMutation,
    useDeleteUserMutation,
    useUpdateUserMutation,
} = user
